module.exports = __webpack_public_path__ + "img/cloud-warning-icon.f39c1af.svg";